
export function MainSection(props: any) {
    return <section className={`main_body ` + props.className}>
        {props.children}
    </section>
}